import React from 'react'
import { useTranslation } from 'react-i18next'
import { SocialWebSourcesWidget } from 'schemas/SocialWebSourcesWidgetSchema'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { usePageConfigUser } from '../../../../../hooks/usePageConfig'
import ErrorMessage from '../../../../share/ErrorMessage'
import { getSearchMetricSeriesList } from '../utils'

const isWidgetEmptyMetricSeries = (widgetSetting: SocialWebSourcesWidget, pageConfigUser: any) =>
  !getSearchMetricSeriesList(widgetSetting, pageConfigUser).length

const EmptySearchMetricSeriesGuard = ({
  widgetId,
  children
}: {
  widgetId: number
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSourcesWidget>(widgetId)
  const pageConfigUser = usePageConfigUser()
  const { t } = useTranslation()

  if (isWidgetEmptyMetricSeries(widgetSetting, pageConfigUser)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default EmptySearchMetricSeriesGuard
